import React from "react";
import Dashboard from "../../components/Dashboard/beautiful/Dashboard";

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;
